// extracted by mini-css-extract-plugin
export default {"hr-mobile":"DisplayedCardContainer-module__hr-mobile__IZGqg"};